import {AuthoringSubjectModelV1} from 'resources/GeneratedModels/AuthoringSubject/AuthoringSubjectModel.v1';

import {subjectExtensions} from 'resources/augmented/Subject/subject.extensions';

import {authoringSubjectExtensions} from './authoringSubject.extensions';
import {authoringSubjectValidators} from './authoringSubject.validators';

AuthoringSubjectModelV1.extend(subjectExtensions, authoringSubjectExtensions);
AuthoringSubjectModelV1.addValidators(authoringSubjectValidators);

export {AuthoringSubjectModelV1};
